import { z } from "zod";

export const sendVoiceGuesserTapSchema = z.object({
	target_user_id: z.string().min(1),
});

export type SendVoiceGuesserTapPayload = z.infer<typeof sendVoiceGuesserTapSchema>;
